/**
 * Utilidades de validación y normalización de códigos postales.
 */

/**
 * Normaliza un código postal según el país (ej. para US toma los primeros 5 dígitos si viene en formato ZIP+4).
 */
export const normalizeZip = (zip?: string | null, country: string = "US"): string => {
  if (!zip) return "";
  let clean = zip.trim();
  const c = country.toUpperCase();
  if (c === "US" && clean.includes("-")) {
    clean = clean.split("-")[0].trim();
  }
  return clean;
};

/**
 * Valida el formato sintáctico del código postal según el país.
 */
export const isValidZipFormat = (zip?: string | null, country: string = "US"): boolean => {
  if (!zip) return false;
  const clean = normalizeZip(zip, country);
  const c = country.toUpperCase();

  switch (c) {
    case "US":
      // Estados Unidos: 5 dígitos exactos
      return /^\d{5}$/.test(clean);
    case "VE":
      // Venezuela: 4 dígitos
      return /^\d{4}$/.test(clean);
    case "DO": // Rep. Dominicana: 5 dígitos
    case "GT": // Guatemala: 5 dígitos
    case "CR": // Costa Rica: 5 dígitos
    case "CU": // Cuba: 5 dígitos
    case "PE": // Perú: 5 dígitos
      return /^\d{5}$/.test(clean);
    default:
      // Genérico internacional: 3 a 10 caracteres alfanuméricos
      return /^[a-zA-Z0-9\s-]{3,10}$/.test(clean);
  }
};

/**
 * Retorna un mensaje de error explicativo cuando el formato es incorrecto.
 */
export const getZipFormatErrorMessage = (country: string = "US"): string => {
  const c = country.toUpperCase();
  switch (c) {
    case "US":
      return "El código postal debe tener 5 dígitos numéricos (ej. 33178).";
    case "VE":
      return "El código postal debe tener 4 dígitos numéricos (ej. 1010).";
    case "DO":
    case "GT":
    case "CR":
    case "CU":
    case "PE":
      return `El código postal debe tener 5 dígitos para ${c}.`;
    default:
      return "Formato de código postal no válido.";
  }
};

/**
 * Retorna un placeholder de ejemplo para el campo de código postal.
 */
export const getZipPlaceholder = (country: string = "US"): string => {
  const c = country.toUpperCase();
  switch (c) {
    case "US":
      return "33178";
    case "VE":
      return "1010";
    case "DO":
      return "10101";
    case "GT":
      return "01001";
    case "CR":
      return "10101";
    case "CU":
      return "10400";
    case "PE":
      return "15001";
    default:
      return "33178";
  }
};
